import { Box, Divider, Flex } from "@chakra-ui/react";
import { Header } from "../../components/Header";
import { Limites } from "./LImites";
import { Search } from "./Search";
import { FormProvider, useForm } from "react-hook-form";
import { useEffect } from "react";
import { Horarios } from "./Horarios";
import { Layout } from "./Layout";
import { Selecionada } from "./Selecionada";
import { PedidoProvider } from "../../Context/PedidoContext";
import { Bilhetes } from "./Bilhetes";
import { Footer } from "../../components/Footer";
import { ModalConexao } from "./ModalConexao";
import Swal from "sweetalert2";

export function Pdv() {
  const form = useForm({
    defaultValues: {
      data_saida: new Date(),
      contexto: 'ida',
      conexao: {
        isConnection: false,
        passagem: null
      },
    },
  });

  useEffect(() => {
    const errorMessage = sessionStorage.getItem('gopass_redirect_error_message');

    if (!errorMessage) {
      return;
    }

    sessionStorage.removeItem('gopass_redirect_error_message');

    const isCreatePixError = errorMessage.trim() === 'Erro ao criar PIX!\nTente novamente!';

    Swal.fire({
      icon: 'error',
      titleText: isCreatePixError ? errorMessage : `${errorMessage}\nFavor gerar uma nova reserva`,
      didOpen: () => {
        const titleElement = Swal.getTitle();
        if (titleElement) {
          titleElement.style.whiteSpace = 'pre-line';
        }
      },
    });
  }, []);

  const formValues = form.watch();
  const layoutSelecionado = Boolean((formValues as any).layout);

  console.log(form.getValues())

  return (
  <PedidoProvider>
    <FormProvider {...form}>
    <ModalConexao />
      <Box
        display={"flex"}
        flexDir={"column"}
        justifyContent={"center"}
        width={"full"}
        alignItems={"center"}
      >
        <Flex
          maxWidth={{
            xs: 'full',
            md: '90%'
          }}
          width={"100%"}
          flexDir={"column"}
          justifyContent={"center"}
        >
          <Header />
          <Box px={"1rem"} bg={"white"} w={"full"}>
            <Limites />
            <Divider />
          </Box>
          <Search />
          <Flex gap={4} pb={4} px={{
            sm: '4px',
            xl: '1rem'
          }} 
          bg={"white"} 
          flexDir={{
            xs: 'column',
            md: 'row',
          }}
          w={"full"}>
            <Box width={{
              sm: 'full',
              md: '80vw',
              xl: '60vw'
            }}>
              <Horarios />
              <Selecionada />
              <Bilhetes />
            </Box>
            {layoutSelecionado && (
              <Flex flex={1} justifyContent={"center"}>
                <Layout />
              </Flex>
            )}
          </Flex>
          <Footer />
        </Flex>
      </Box>
    </FormProvider>
  </PedidoProvider>
  );
}
